"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const options_1 = require("./options");
function getStyles(position, containerStyle) {
    const initialStyles = {
        position: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        pointerEvents: 'none',
        overflow: 'visible',
        ...(containerStyle
            ? {
                top: `${containerStyle.top}px`,
                left: `${containerStyle.left}px`,
                height: `${containerStyle.height}px`,
                width: `${containerStyle.width}px`,
            }
            : { width: '100%', height: '100%' }),
    };
    switch (position) {
        case options_1.positions.TOP_LEFT:
            return {
                ...initialStyles,
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
            };
        case options_1.positions.TOP_CENTER:
            return {
                ...initialStyles,
                justifyContent: 'flex-start',
            };
        case options_1.positions.TOP_RIGHT:
            return {
                ...initialStyles,
                justifyContent: 'flex-start',
                alignItems: 'flex-end',
            };
        case options_1.positions.MIDDLE_LEFT:
            return {
                ...initialStyles,
                justifyContent: 'center',
                alignItems: 'flex-start',
            };
        case options_1.positions.MIDDLE: {
            return {
                ...initialStyles,
                justifyContent: 'center',
            };
        }
        case options_1.positions.MIDDLE_RIGHT:
            return {
                ...initialStyles,
                justifyContent: 'center',
                alignItems: 'flex-end',
            };
        case options_1.positions.BOTTOM_LEFT:
            return {
                ...initialStyles,
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
            };
        case options_1.positions.BOTTOM_CENTER:
            return {
                ...initialStyles,
                justifyContent: 'flex-end',
            };
        case options_1.positions.BOTTOM_RIGHT:
            return {
                ...initialStyles,
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
            };
        default: {
            return initialStyles;
        }
    }
}
function Wrapper({ children, options: { position }, containerStyle, ...props }) {
    const styles = (0, react_1.useMemo)(() => getStyles(position, containerStyle), [position, containerStyle]);
    return (children.length > 0 && ((0, jsx_runtime_1.jsx)("div", { style: styles, ...props, children: children })));
}
exports.default = Wrapper;
